import { Download as ExportIcon } from '@tunasong/icons'
import type { TunaPlugin } from '@tunasong/plugin-lib'
import { getExportSpaceCommands } from './commands.js'
import { useExportReadyAlert } from './hooks/use-export-ready-alert.js'

export { useExportReadyAlert }
export { containerExitCode } from './describe-export-failure.js'

/** Export a space from where the intent forms — the space itself (spec 2026-09-09 §3, §4) */
const plugin = (): TunaPlugin => ({
  key: 'export',
  icon: ExportIcon,
  description: 'Export a space as a zip a local Tunasong opens directly',
  getContextCommands: getExportSpaceCommands,
})

export default plugin
